import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RoleDto } from 'shared';
import { NotificationService } from 'shared';
import { OAuthServiceService } from 'shared';
import { TenantService } from 'shared';
import { TranslateService } from 'shared';

@Component({
    selector: 'delete-tenant-grouprole-dialog',
    templateUrl: './delete-tenant-grouprole-dialog.component.html',
    styleUrls: ['./delete-tenant-grouprole-dialog.component.css'],
    standalone: false
})
export class DeleteTenantGrouproleDialogComponent implements OnInit {

    groupRoleForm!: UntypedFormGroup;
    roleDto!: RoleDto;
    _db!:string;
    tenantName!: string;
    rowData!: any;
  
    constructor(private fb: UntypedFormBuilder,
      public dialogRef: MatDialogRef<DeleteTenantGrouproleDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private tenantService:TenantService,
      private oauthService: OAuthServiceService,
      public translate: TranslateService,
      private notificationService: NotificationService) { }
  
    ngOnInit(): void {
      // this.oauthService.userData.subscribe({
      //   next: (data) => {
      //     if (typeof data != undefined && data != null) {
      //       let userRoles = (data as any).role as Array<string>;
      //       userRoles.forEach((dbrole: string) => {
      //         if (dbrole === 'admin') {
      //          this._db = dbrole;
      //         }
      //       });
      //     }
      //   }
      // });
      
      this.tenantName = this.data.tenantName;
      this.data = this.data.rowData;
      this.createGroupRoleForm();
    }
  
    createGroupRoleForm(){
      this.groupRoleForm = this.fb.group({
        groupRoleId:[this.data.id],
        // projectId:[this.data.projectId],
        name:[this.data.name]
      });
    }
  
    deleteGroupRole(id: string){
      if(this.groupRoleForm.valid){
        //let db:string = this.tenantService.currentTenantName;
        this.tenantService.deleteTenantGroupRole(this.tenantName, id).subscribe({
      //this.platformGroupRoleService.getPlatformPermissions().subscribe({
          next: () => {
            //this.refresh(this.params);
            this.dialogRef.close(this.groupRoleForm.value);
            this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["TENANTGROUPROLEDELETED"]} `);
            //this.dialog.open(TenantPermissionsComponent, {width: '500px', data:{tenantGroupRole: tenantGroupRole, tenantGroupRolePermissions: null}});
          },
          error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["TENANTGROUPROLEDELETEDERROR"]}`)
        });
      }
    }

    cancel() {
      this.dialogRef.close(this.groupRoleForm.value);
    }
  
  } 
